// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shell for /catalog — header + section tabs + scrollable outlet.
   Tab styles live in components/layout/AppSectionTabs.module.css. */

/* The shell for every top-level page: /catalog/* and /projects, which used to
   restate this as an inline style object on ProjectsList. */
.njcldmjCZtxW7vK9QDCD {
  /* Bounded height, not min-height: html/body never scroll (overflow:hidden in
     MainCanvas.css, injected app-wide), so each region must own its scroll
     within the viewport or overflowing content is simply unreachable (#161). */
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-family: var(--curio-font-family);
  background: var(--curio-page-bg);
  color: var(--curio-text-primary);
  /* Reserve the bottom-right corner for the fixed VersionBadge (#236). The
     height chain from here is unbroken to the viewport - .outlet, .page, then
     .browseDrawer at height:100% - so without this the details drawer runs its
     own CTA under the badge. Bounded height means border-box is load-bearing:
     the padding has to come out of the 100vh, not add to it. */
  box-sizing: border-box;
  padding-bottom: var(--curio-version-badge-reserve);
}

.CAkZU_omUm2d3Osd0Wpw {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/pages/catalog/CatalogMasterPage.module.css"],"names":[],"mappings":"AAAA;oEACoE;;AAEpE;4DAC4D;AAC5D;EACE;;+EAE6E;EAC7E,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC;;;;+DAI6D;EAC7D,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* Shell for /catalog — header + section tabs + scrollable outlet.\n   Tab styles live in components/layout/AppSectionTabs.module.css. */\n\n/* The shell for every top-level page: /catalog/* and /projects, which used to\n   restate this as an inline style object on ProjectsList. */\n.pageShell {\n  /* Bounded height, not min-height: html/body never scroll (overflow:hidden in\n     MainCanvas.css, injected app-wide), so each region must own its scroll\n     within the viewport or overflowing content is simply unreachable (#161). */\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--curio-font-family);\n  background: var(--curio-page-bg);\n  color: var(--curio-text-primary);\n  /* Reserve the bottom-right corner for the fixed VersionBadge (#236). The\n     height chain from here is unbroken to the viewport - .outlet, .page, then\n     .browseDrawer at height:100% - so without this the details drawer runs its\n     own CTA under the badge. Bounded height means border-box is load-bearing:\n     the padding has to come out of the 100vh, not add to it. */\n  box-sizing: border-box;\n  padding-bottom: var(--curio-version-badge-reserve);\n}\n\n.outlet {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageShell": `njcldmjCZtxW7vK9QDCD`,
	"outlet": `CAkZU_omUm2d3Osd0Wpw`
};
export default ___CSS_LOADER_EXPORT___;
